<template>
  <NuxtLink
    :to="link"
    :target="isExternal ? '_blank' : undefined"
    class="font-avuText text-xl text-avu-black transition duration-200 cursor-pointer ease-in-out hover:text-avu-blue hover:underline hover:underline-offset-8 sm:text-[22px]/[26px] xl:text-[26px]/[30px]"
  >
    <span v-html="text" />
  </NuxtLink>
</template>

<script setup>
  const props = defineProps(["text", "link"]);

  const isExternal = computed(() => /^(http|https|\/\/)/.test(props.link));
</script>
